export const ROW_PINNED_BOTTOM_DATA_COMPONENT_SELECTOR = 'row-pinned-bottom-1ns7';
